import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './Components/App/App';
import './index.css';

declare global {
  // tslint:disable-next-line
  interface Window {
      kanaloversikt: {
          init: (container: HTMLElement, parameter: string) => void;
      }
  }
}

window.kanaloversikt = {
  init: (container, parameter) => {
      ReactDOM.render(
          <App parameter={parameter} />,
          container
      );
  }
};


// window.kanaloversikt.init(document.getElementById("faste")!, "faste");
// window.kanaloversikt.init(document.getElementById("valgfrie")!, "valgfrie");
// window.kanaloversikt.init(document.getElementById("kanalpakker")!, "kanalpakker");
